import { Skeleton } from '@mint-lib/tw-components';

const SkeletonMarkup = () => (
  <>
    <div className="mb-4">
      <Skeleton variant="rounded" className="mb-2 h-4 w-35" />
      <div className="flex">
        <Skeleton variant="circle" className="mr-2 mb-1 h-8 w-8" />
        <div>
          <Skeleton variant="rounded" className="mb-1 h-8 w-32" />
          <Skeleton variant="rounded" className="h-5 w-12" />
        </div>
      </div>
    </div>
    <Skeleton variant="rounded" className="h-10" />
  </>
);

export default SkeletonMarkup;
